var Handlebars = require("../../lice.thomasjacob.de/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "		<i class=\"fa fa-check\"></i>\n		&nbsp;\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,__default(require("./handlebars/eq.js")).call(alias1,(depth0 != null ? depth0.type : depth0),"error",{"name":"eq","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    return "		<i class=\"fa fa-exclamation-triangle\"></i>\n		&nbsp;\n	";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=depth0 != null ? depth0 : (container.nullContext || {});

  return "<p class=\"message message--"
    + container.escapeExpression(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias2,__default(require("./handlebars/eq.js")).call(alias2,(depth0 != null ? depth0.type : depth0),"ok",{"name":"eq","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "	"
    + ((stack1 = alias1((depth0 != null ? depth0.message : depth0), depth0)) != null ? stack1 : "")
    + "\n</p>\n";
},"useData":true});